import { useContext } from 'react';
import { UiContext, UiState } from '../context';
import { SideBarOptions } from '../interfaces';

interface UseUi extends UiState {
  handleToggleSidebar: (optionSidebarOpen: SideBarOptions) => void;
  handleCloseSidebar: () => void;
}

export const useUi = (): UseUi => {
  const { optionSidebarOpen, isOpenSideBar, toggleSidebar, closeSidebar } = useContext( UiContext );

  const handleToggleSidebar = (optionSidebarOpen: SideBarOptions) => {
    toggleSidebar(optionSidebarOpen);
  }

  const handleCloseSidebar = () => {
    closeSidebar();
  }

  return {
    isOpenSideBar,
    optionSidebarOpen,
    handleToggleSidebar,
    handleCloseSidebar
  }
}